import { FC } from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";

type Props = {
  brandName?: string;
  isFetching?: boolean;
};

const DiscountDetailsHeaderWeb: FC<Props> = ({ brandName, isFetching }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb
      className="font-semibold!"
      classNames={{
        item: "flex! items-center!",
      }}
      items={[
        {
          title: <Link to="..">{t("Menu.discounts")}</Link>,
        },
        {
          title: isFetching ? <SkeletonBox className="flex h-5 w-20" /> : brandName,
        },
      ]}
    />
  );
};

export default DiscountDetailsHeaderWeb;
